let namespace = "report";

export default {
	GET_REPORT: `${namespace}/GET_REPORT`,
	GET_FEILD_MAPPING: `${namespace}/GET_FEILD_MAPPING`,
};
